import './types';
import { persistentKVStore } from '@water-web/view';

import { AppLocale } from './locales';

export const getPersistedLocale = (): AppLocale => {
  let persistedLocale = AppLocale.en;

  // Using try catch instead of checking for existence of an object,
  // because we may actually have it defined but get a security error
  try {
    persistedLocale = persistentKVStore.getItem('SQUIRE_WIDGET_LOCALE') as AppLocale;
  } catch (e) {
    persistedLocale = (window.SQUIRE_WIDGET_LOCALE as AppLocale) || AppLocale.en;
  }

  return persistedLocale;
};

const isValidLocale = (locale: string): locale is AppLocale => {
  return Object.values(AppLocale).includes(locale as AppLocale);
};

const getLocaleFromStorage = (): string | null => {
  try {
    return persistentKVStore.getItem('SQUIRE_WIDGET_LOCALE');
  } catch (e) {
    return null;
  }
};

export const getMaybePersistedLocale = (): AppLocale | null => {
  const persistedLocale = getLocaleFromStorage();

  if (!persistedLocale) {
    return null;
  }

  if (!isValidLocale(persistedLocale)) {
    return null;
  }
  return persistedLocale;
};
